import { createReducer, on } from '@ngrx/store'
import * as notificationsActions from './notifications.actions'
import { Notification } from './notifications.interfaces'

export interface NotificationsState {
    notifications: Notification[] | null
    notificationsError: boolean
    notificationsLoading: boolean
}

export const initialState: NotificationsState = {
    notifications: null,
    notificationsError: null,
    notificationsLoading: null,
}

export const NotificationsReducer = createReducer(
    initialState,

    on(notificationsActions.fetchNotifications, (state) => ({
        ...state, notifications: null, notificationsError: null, notificationsLoading: true
    })),

    on(notificationsActions.fetchNotificationsSuccess, (state, {notifications}) => ({
        ...state, notifications: notifications, notificationsError: false, notificationsLoading: false
    })),

    on(notificationsActions.fetchNotificationsFailed, (state) => ({
        ...state, notifications: null, notificationsError: true, notificationsLoading: false
    })),

)